import { useState } from "react";
import { bool, string, func } from "prop-types";
import { useTranslation } from "react-i18next";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import * as yup from "yup";
import { MAX_ESTIMATE_TITLE_LENGTH } from "@utils";
import { IconButton } from "@material-ui/core";
import { TextClearInput } from "./index";
import { Clear } from "@material-ui/icons";
import classnames from "classnames";

export const EstimateNameEditorV2 = ({
  name,
  onSubmit,
  useH1,
  allowEdition = true,
}) => {
  const { t } = useTranslation();

  const [ focused, setFocus ] = useState(false);
  
  const {
    control,
    handleSubmit,
    reset,
  } = useForm({
    resolver: yupResolver(
      yup.object().shape({
        name: yup
          .string()
          .required(t("errors.project.name.required"))
          .min(4, t("errors.project.name.min"))
          .max(MAX_ESTIMATE_TITLE_LENGTH, t("errors.project.name.max"))
      })
    ),
    defaultValues: { name },
  });

  const handleFocus = () => {
    if (allowEdition)
      setFocus(true);
  };
  
  const handleCancel = () => {
    setFocus(false);
    reset();
  }

  const submitHandler = async (data) => {
    if (!data.name.length)
      reset();
    else if (name !== data.name) {
      const newName = data.name.trim();
      onSubmit(newName);
    }
    setFocus(false);
  };

  if(!allowEdition) {
    const inactiveProps = {
      className: classnames("preset-title cursor-text ellipsis"),
    }

    return useH1
      ? <h1 {...inactiveProps}>{ name }</h1>
      : <h2 { ...inactiveProps }>{ name }</h2>
  }

  return <Controller
    name="name"
    control={control}
    render={({ field: { onChange, value }, fieldState: { error } }) => (
      <TextClearInput
        multiline
        onChange={onChange}
        value={value}
        focused={focused}
        error={Boolean(error)}
        errorMessage={error?.message}
        onFocus={handleFocus}
        onAccept={handleSubmit(submitHandler)}
        acceptOnClickAway
        lockSpecialCharacters={false}
        placeholder={t("views.active.popup.name")}
        confirmOnEnter
        scaleWidthToContent
        containerClass="name"
        inputClassName={classnames("py-1-5", useH1 ? "text-h1" : "text-h2")}
        preventClickAwayOnElement="#libraryElementSelector"
        endAdornment={
          <IconButton
            onClick={ handleCancel }
            className="p-0 ml-1 text-2xl"
            color="primary"
          >
            <Clear />
          </IconButton>
        }
      />
    )}
  />
  
};

EstimateNameEditorV2.propTypes = {
  onSubmit: func.isRequired,
  name: string.isRequired,
  className: string,
  formClassName: string,
  allowEdition: bool,
  useH1: bool,
};